import {
  SET_PAYMENT_DATA,
  SAVE_REDUX_STATE_TO_STORAGE,
  RESET_PAYMENT_DATA,
  SET_MAILING_ID_PROMO
} from '../../constants/actions';

export function setPaymentData (data) {
  return dispatch => dispatch({type: SET_PAYMENT_DATA, data});
}

export function saveReduxStateToStorage () {
  return dispatch => dispatch({type: SAVE_REDUX_STATE_TO_STORAGE});
}

export function resetPaymentData () {
  return dispatch => dispatch({type: RESET_PAYMENT_DATA});
}

export function setMailingIdPromo (data) {
  return dispatch => dispatch({type: SET_MAILING_ID_PROMO, data});
}



// WEBPACK FOOTER //
// ./src/store/actions/paymentData.js